import { Modal } from "antd";
import AddUserForm from "./AddUserForm";
import { User } from "./UsersTab";
import { UserRound } from "lucide-react";

interface Props {
    addNewUserModal: boolean;
    closeModel: () => void;
    isEdit?: boolean;
    id?: string | number;
    getUser?: (user: User[]) => void;
}

const AddNewUser = ({ isEdit = false, id = "", addNewUserModal, closeModel, getUser }: Props) => {
    return (
        <Modal 
            open={addNewUserModal}
            width={760}
            footer={false}
            onCancel={closeModel}
            destroyOnClose
            centered
            styles={{
                mask: { backdropFilter: 'blur(4px)' },
                content: { borderRadius: '24px', padding: '24px' }
            }}
            title={
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
                    <div
                        style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '12px',
                            backgroundColor: '#3f8b98',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            boxShadow: '0 8px 16px rgba(63, 139, 152, 0.15)'
                        }}
                    >
                        <UserRound size={20} strokeWidth={2.4} color="#fff" />
                    </div>
                    <h2 style={{ fontSize: "20px", fontWeight: 700, margin: 0, color: "#0f172a", letterSpacing: '-0.02em' }}>
                        {isEdit ? "Edit User" : "Add New User"}
                    </h2>
                </div>
            }
        >
            <div style={{ marginTop: '12px' }}>
                <AddUserForm getUser={getUser} id={id} isEdit={isEdit} closeModal={closeModel} />
            </div>
        </Modal>
    )
}

export default AddNewUser;